import { render, staticRenderFns } from "./v-navbar-navigation.vue?vue&type=template&id=7a2026c1&scoped=true&"
var script = {}
import style0 from "./v-navbar-navigation.vue?vue&type=style&index=0&id=7a2026c1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a2026c1",
  null
  
)

export default component.exports